import { createSlice } from '@reduxjs/toolkit'

const contactSupportSlice = createSlice({
  name: 'contactSupport',
  initialState: {
    tier: null,
    showModal: false
  },
  reducers: {
    resetShowContactSupportModal: (state) => {
      state.tier = null
      state.showModal = false
    },
    setContactSupportVisible: (state, action) => {
      state.tier = action.payload.tier
      state.showModal = true
    }
  }
})

export const {
  reducer,
  actions: {
    resetShowContactSupportModal,
    setContactSupportVisible
  }
} = contactSupportSlice
